import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fa7ba0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full pb-3 pt-6 text-xs xs:text-sm sm:pt-8 sm:text-base lg:text-lg xl:text-xl" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl px-3 sm:px-4" }
const _hoisted_3 = { class: "text-center" }

import DevelopedByWithLogo from '@/components/App/DevelopedByWithLogo.vue';
import {
  CONFIG,
} from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicFooter',
  setup(__props) {

const currentYear = new Date().getFullYear();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, " Copyright © " + _toDisplayString(_unref(currentYear)) + " " + _toDisplayString(_unref(CONFIG).appName) + ", All Rights Reserved. ", 1),
      _createVNode(DevelopedByWithLogo, { class: "mt-2" })
    ])
  ]))
}
}

})